import { all } from "redux-saga/effects";
import authSagas from "./Auth";
import businessSagas from "./Business";
import bookAppointmentSagas from "./BookAppointment";
import customerBookingPageSagas from "./CustomerBooking";
import EmployeeSagas from "./EmployeeSaga";
import LoginSagas from "./LoginSaga";
import AdminBookAppointment from "./AdminBookAppointment";
import CustomerAdminSaga from "./CustomerAdminSaga";
import ServicesAdminSaga from "./ServicesAdminSaga";
import AdminSettings from "./AdminSettings";
import ReportsSaga from "./Reports.Saga";
import BusinessSaga from "./BusinessSaga";
import ServicesSuperAdminSaga from './ServicesSuperAdminSaga';
import CategorySuperAdminSaga from './CategorySuperAdminSaga';
import UserSaga from './UserSaga';
import CustomerAppointment from './CustomerAppointment';
import CustomerProfile from "./CustomerProfile";

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    businessSagas(),
    bookAppointmentSagas(),
    customerBookingPageSagas(),
    EmployeeSagas(),
    LoginSagas(),
    AdminBookAppointment(),
    CustomerAdminSaga(),
    ServicesAdminSaga(),
    AdminSettings(),
    ReportsSaga(),
    BusinessSaga(),
    ServicesSuperAdminSaga(),
    CategorySuperAdminSaga(),
    UserSaga(),
    CustomerAppointment(),
    CustomerProfile(),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/index.js